<template>
  <div class="field">
    <label>決済方法</label>
    <div class="select-wrap">
      <select
        v-model="paymentMethodSelected"
        @change="setPaymentMethod(paymentMethodSelected)"
      >
        <option
          v-for="paymentMethod in paymentMethods"
          :key="paymentMethod.id"
          :value="paymentMethod"
        >
          {{ paymentMethod.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "PaymentMethodSelect",
  setup() {
    const store = useStore();

    const paymentMethods = store.getters["ticketing/paymentMethods"];
    const inputStorePaymentMethod =
      store.getters["input/ticketing/storePaymentMethod"];

    const setPaymentMethod = (paymentMethod) => {
      store.commit("input/ticketing/setStorePaymentMethod", paymentMethod);
    };

    //set default selection
    const paymentMethodSelected = ref(paymentMethods[0]);

    if (inputStorePaymentMethod) {
      paymentMethodSelected.value = inputStorePaymentMethod;
    } else {
      setPaymentMethod(paymentMethodSelected.value);
    }

    return { paymentMethods, paymentMethodSelected, setPaymentMethod };
  },
};
</script>

<style lang="scss" scoped>
.field {
  position: relative;
  margin: 0 0 15px 0;
}

label {
  position: absolute;
  width: 150px;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}

/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 42px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 0;
  background-color: #ffffff;
  outline: none;
  padding: 5px 10px 5px 75px;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: bold;
  color: #000000;
}

/* 横幅375px以下に適用されるCSS（iPhone SE 第2世代以下のサイズ用） */
@media screen and (max-width: 375px) {
  select {
    font-size: 0.75rem;
  }
}

select:focus {
  border-color: #e0e0e0;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 0;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 15px;
  margin-top: -6px;
}
</style>
